import { useEffect, useState } from "react";
import { Box, Button, Text } from "@chakra-ui/react";
import { typedSxMap } from "../../utils/typedSxMap";
import { Option, ToggleFilterProps } from "./types";

const styles = typedSxMap({
  toggleFilter: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "var(--color-toggle-background)",
    borderRadius: "20px",
    overflow: "hidden",
    height: "40px",
    width: "fit-content",
  },
  toggleOption: {
    padding: "8px 16px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 500,
    backgroundColor: "transparent",
    borderRadius: "20px",
    display: "block",
    maxHeight: "100%",
    minWidth: 0,

    defaultColor: {
      color: "var(--color-text)",
    },
    span: {
      fontWeight: "700",
    },
  },
  selected: {
    backgroundColor: "var(--color-background-pill-hover)",
    borderRadius: "20px",
    // transition: "background-color 0.2s, color 0.2s",
    "&:hover": {
      backgroundColor: "var(--color-background-pill-hover)",
    },
  },
});
function ToggleFilter({ options, onChange, className }: ToggleFilterProps) {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  useEffect(() => {
    const defaultSelected = options.find((option) => option.selected);
    setSelectedOption(defaultSelected ? defaultSelected.label : options[0]?.label);
  }, [options]);

  const handleClick = (option: Option) => {
    setSelectedOption(option.label);
    if (onChange) {
      onChange(option.filterValue);
    }
  };

  const getOptionColor = (option: Option) => {
    if (option.color && option.colorSelected) {
      return selectedOption === option.label ? option.colorSelected : option.color;
    }
    if (option.color) {
      return option.color;
    }
    return selectedOption === option.label ? "var(--color-tertiary)" : "var(--color-text)";
  };

  return (
    <Box sx={styles.toggleFilter}>
      {options.map((option) => (
        <Button
          key={option.label}
          sx={{
            ...styles.toggleOption,
            ...(selectedOption === option.label ? styles.selected : {}),
            ...(option.color && (styles as any)[option.color]),
          }}
          onClick={() => handleClick(option)}
          style={{ color: getOptionColor(option) }}>
          {option.label} <span>{option.count}</span>
        </Button>
      ))}
    </Box>
  );
}

export default ToggleFilter;
